import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useMutableRef } from '@carnica/utils/hooks';
import { useCallback } from 'react';
import { ymPushClickRefreshCaptcha, ymPushViewCaptcha } from "../../../../../shared/analytics";
import { generateCapthcaThunk, useAppDispatch, useAppSelector, validateCaptchaThunk } from "../../../../../shared/model";
import { addProcessId, removeProcessId, selectCaptchaData, selectRecreateCount, setActiveCaptchaMessageId, setCaptchaData, setRecreateCount } from "../../../model/redux";
var defaultCaptchaSize = {
  width: 220,
  height: 68
};
export var useCaptchaActions = function useCaptchaActions(updateMessage, config) {
  var dispatch = useAppDispatch();
  var captchaRef = useMutableRef(useAppSelector(selectCaptchaData));
  var reacreateRef = useMutableRef(useAppSelector(selectRecreateCount));
  var createCaptcha = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var resultAction, _config$authZoneConfi;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return dispatch(generateCapthcaThunk(defaultCaptchaSize));
        case 2:
          resultAction = _context.sent;
          if (!generateCapthcaThunk.fulfilled.match(resultAction)) {
            _context.next = 6;
            break;
          }
          ymPushViewCaptcha((_config$authZoneConfi = config.authZoneConfig) === null || _config$authZoneConfi === void 0 ? void 0 : _config$authZoneConfi.zoneType);
          return _context.abrupt("return", resultAction.payload);
        case 6:
          return _context.abrupt("return", null);
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), [config.authZoneConfig]);
  var captchaUpdate = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id) {
      var captcha, _captcha$captchaId, _captcha$image, _config$authZoneConfi2;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            if (id) {
              dispatch(addProcessId(id));
              dispatch(setActiveCaptchaMessageId(id));
            }
            _context2.next = 4;
            return createCaptcha();
          case 4:
            captcha = _context2.sent;
            dispatch(setCaptchaData(captcha !== null && captcha !== void 0 ? captcha : undefined));
            if (id) {
              if (captcha) {
                dispatch(setActiveCaptchaMessageId(captcha.captchaId));
                dispatch(setRecreateCount(reacreateRef.current + 1));
              }
              updateMessage({
                id: id,
                messageId: (_captcha$captchaId = captcha === null || captcha === void 0 ? void 0 : captcha.captchaId) !== null && _captcha$captchaId !== void 0 ? _captcha$captchaId : id,
                captcha: (_captcha$image = captcha === null || captcha === void 0 ? void 0 : captcha.image) !== null && _captcha$image !== void 0 ? _captcha$image : null
              });
            }
          case 7:
            _context2.prev = 7;
            ymPushClickRefreshCaptcha((_config$authZoneConfi2 = config.authZoneConfig) === null || _config$authZoneConfi2 === void 0 ? void 0 : _config$authZoneConfi2.zoneType);
            if (id) {
              dispatch(removeProcessId(id));
            }
            return _context2.finish(7);
          case 11:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0,, 7, 11]]);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [config.authZoneConfig]);
  var validateCaptcha = useCallback( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(value) {
      var data, resultAction;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!captchaRef.current) {
              _context3.next = 8;
              break;
            }
            data = {
              captchaValue: value,
              captchaText: captchaRef.current.captchaText,
              cookieToken: captchaRef.current.captchaTokenValue,
              captchaId: captchaRef.current.captchaId
            };
            _context3.next = 4;
            return dispatch(validateCaptchaThunk(data));
          case 4:
            resultAction = _context3.sent;
            if (!validateCaptchaThunk.fulfilled.match(resultAction)) {
              _context3.next = 7;
              break;
            }
            return _context3.abrupt("return", {
              type: 'success',
              data: resultAction.payload
            });
          case 7:
            return _context3.abrupt("return", {
              type: 'error',
              data: resultAction.payload
            });
          case 8:
            return _context3.abrupt("return", null);
          case 9:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x2) {
      return _ref3.apply(this, arguments);
    };
  }(), []);
  return {
    createCaptcha: createCaptcha,
    validateCaptcha: validateCaptcha,
    captchaUpdate: captchaUpdate
  };
};